import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLetter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "1 3 18 14",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.8089 10.5984L16.5639 8.0526C17.1481 7.65759 17.4973 6.99843 17.4973 6.29342V6.29342C17.4973 5.11842 16.5456 4.16675 15.3714 4.16675H4.6356C3.46143 4.16675 2.50977 5.11842 2.50977 6.29259V6.29259C2.50977 6.99759 2.85893 7.65676 3.4431 8.0526L7.1981 10.5984C8.89227 11.7468 11.1148 11.7468 12.8089 10.5984V10.5984Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.49731 6.29248V14.1667C2.49731 15.5475 3.61648 16.6667 4.99731 16.6667H14.9973C16.3781 16.6667 17.4973 15.5475 17.4973 14.1667V6.29331",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLetter;
